"use client";

import { FC, useEffect } from "react";

import { usePathname } from "next/navigation";

import { EventNames as NREventNames } from "~/constants/new-relic";
import { getMessageFromGraphQLError } from "~/helpers/get-message-from-graphql-error";

import { NRManagableError, ServiceErrorPageProps } from "./types";

export const NewRelicIntegration: FC<ServiceErrorPageProps> = (
  props: ServiceErrorPageProps,
) => {
  const {
    statusCode = 500,
    error = new Error("An error details has not provided"),
  } = props;
  const pathname = usePathname();

  useEffect(() => {
    if (statusCode && error && !(error as NRManagableError).isNRCatched) {
      // eslint-disable-next-line no-restricted-globals
      window.newrelic?.addPageAction(NREventNames.renderOopsPage, {
        statusCode,
        error:
          getMessageFromGraphQLError(error) ||
          `Unhandled error ${JSON.stringify(error)}`,
        stack: error?.stack,
        digest: (error as NRManagableError).digest,
      });

      (error as NRManagableError).isNRCatched = true;
    }
  }, [pathname, statusCode, error]);

  return null;
};
